import fetchCart, { cartTotal } from './fetchCart';
import updateCartNotification from './updateCartNotification';

/**
 * Fetches the cart then updates the cart notification, and
 * sets up an event listener for other cart updates
 *
 * @param {Element} cartEl Cart element
 */
const setupCart = async (cartEl) => {
  if (!cartEl) return;

  const cartData = await fetchCart();
  const total = cartTotal(cartData);

  updateCartNotification(total, cartEl);

  // add event listener for cart notification updates after page load (eg. item removed from cart)
  document.addEventListener(
    'cart.lineItemCount.change',
    ({ detail: { data } }) => {
      updateCartNotification(data?.lineItemCount, cartEl);
    }
  );
};

export default setupCart;
